import { create } from 'zustand';

interface AuthState {
  userType: 'doctor' | 'parent' | null;
  isAuthenticated: boolean;
  setUserType: (userType: 'doctor' | 'parent') => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  userType: localStorage.getItem('userType') as 'doctor' | 'parent' | null,
  isAuthenticated: !!localStorage.getItem('userType'),
  setUserType: (userType) => {
    localStorage.setItem('userType', userType);
    set({ userType, isAuthenticated: true });
  },
  clearAuth: () => {
    localStorage.removeItem('userType');
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user_type');
    localStorage.removeItem('user_email');
    localStorage.removeItem('isAuthenticated');
    set({ userType: null, isAuthenticated: false });
  },
}));
